module.exports = __webpack_public_path__ + "@/assets/img/emailHeader.2b15eac8.jpg";